"use client";
import { useMemo } from "react";

export const useFormattedDate = (dateString?: string) => {
  return useMemo(() => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const rawMonth = date.toLocaleString("default", {
      month: "short",
      timeZone: "UTC",
    });
    const capitalizedMonth =
      rawMonth.charAt(0).toUpperCase() + rawMonth.slice(1);
    const year = date.getUTCFullYear();
    return `${day} ${capitalizedMonth} - ${year}`;
  }, [dateString]);
};
